(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('TelesaqueB2bSendingProposalController', telesaqueB2bSendingProposalController);

    telesaqueB2bSendingProposalController.$inject = ['$rootScope', 'CompanyService', 'NotificationService'];

  function telesaqueB2bSendingProposalController ($rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.b2bTelesaqueSendingProposal');

    var vmTelesaqueB2bSendingProposalCtrl = this;

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmTelesaqueB2bSendingProposalCtrl.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
      });

      vmTelesaqueB2bSendingProposalCtrl.allow = function () {
      CompanyService
        .saveMetadata(vmTelesaqueB2bSendingProposalCtrl.metadata)
        .$promise
        .then(function (data) {
          vmTelesaqueB2bSendingProposalCtrl.metadata = data;
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.saveConfig);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig);
        });
    };
  }
})();
